<div class="container">
  <h1>404</h1>
  <p>You have visited a page that does not exist.</p>
  <img src="https://i.giphy.com/media/TqiwHbFBaZ4ti/giphy.webp" alt="" />
</div>
